/**
 * Light or dark. web/public/theme-boot.js makes the first decision before the
 * bundle runs; this owns it afterwards. Same storage key, so the two agree.
 */

import { useCallback, useEffect, useState } from 'react';
import { tellDesktopTheme } from './desktop';

export type Theme = 'light' | 'dark';

const KEY = 'mauvely.theme';

function current(): Theme {
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(current);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.style.colorScheme = theme;
    // Inside the desktop app, its title bar follows.
    void tellDesktopTheme(theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((t) => {
      const next: Theme = t === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem(KEY, next);
      } catch {
        // Private mode: the choice lasts for this page only.
      }
      return next;
    });
  }, []);

  return [theme, toggle];
}
